import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";
import { fetchAllDataAPI } from "../utils/api";


const PieChartProductOrder = () => {
    const [data, setData] = useState([["Month", "Orders"]]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchYearlyOrderData();
    }, []);

    const fetchYearlyOrderData = async () => {
        setIsLoading(true);
        try {
            const res = await fetchAllDataAPI("super-admin-get-all-order-delivery-ratio");
            console.log("API Response:", res);
            if (res.data.status === 1) {
                const transformedData = transformYearlyData(res.data.orderData);
                console.log("Transformed Data:", transformedData);
                setData([["Month", "Orders"], ...transformedData]);
            } else {
                console.error("API Error Message:", res.data.msg);
            }
        } catch (error) {
            console.error("Fetch Error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const transformYearlyData = (data) => {
        const monthMapping = {
            1: "January",
            2: "February",
            3: "March",
            4: "April",
            5: "May",
            6: "June",
            7: "July",
            8: "August",
            9: "September",
            10: "October",
            11: "November",
            12: "December",
        };
        return data.map((item) => [monthMapping[item.month], parseInt(item.total, 10)]);
    };

    const options = {
        is3D: true,
        title: "Yearly Order Distribution",
        pieSliceText: "percentage",
        chartArea: { width: "90%", height: "80%" },
        legend: { position: "right" },
        tooltip: {
            text: "both",
        },
    };

    return (
        <div className="piechart3d">
            {isLoading ? (
                <p>Loading...</p>
            ) : (
                <Chart
                    chartType="PieChart"
                    data={data}
                    options={options}
                    width={"100%"}
                    height={"400px"}
                />
            )}
        </div>
    );
};

export default PieChartProductOrder;
